<template>
    <div
      class="u-height100 u-mt3"
    >
        <h2 class="u-m0 u-py1 u-brand-dark u-text--md">Activity</h2>
        <ul
          style="list-style: circle;"
          class="u-pl3"
        >
            <li
              v-for="item in list"
              :key="item.id"
            >
                <div class="l-flex-grid u-text--sm u-mb3">
                  <span class="u-text--light">{{ item.type == "post" ? "Created" : "Modified" }} by {{ item.modified_by.name }}</span>
                  <div class="date u-ml-auto c-inline-status__secondary-label u-text--sm">
                      <bc-date-display
                       :date="item.date_modified"
                       format="D, MMMM YYYY"
                      />
                  </div>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  }
}
</script>
